import { formMetaDataGetters } from '@/store/modules/formMetaData/routines'

export default {
  [formMetaDataGetters.FORM_META_DATA]: state => state.formMetaData,
  [formMetaDataGetters.FORM_FILE_TO_UPLOAD]: state => state.formFileToUpload,
  [formMetaDataGetters.FORM_FILE_TO_DELETE]: state => state.formFileToDelete
}
